export default {
  common: {
    clearAll: 'Borrar Todo',
    required: 'Requerido',
    restart: 'Reiniciar'
  },
  error: {
    downloadPlay: 'Si ya tienes una cuenta, descarga la última versión de Play e inicia sesión.',
    emailTaken: 'Este correo electrónico ya está en uso',
    fieldTooLong: 'Algunos campos son demasiado largos. Acórtalos e inténtalo de nuevo',
    oops: '¡Vaya!',
    restart: 'Parece que estás intentando usar algo que todavía estamos desarrollando...',
    tryAgain:
      'Por favor, inténtalo de nuevo, si este error continúa, contacta con el equipo de soporte de Metrica Sports',
    userKey:
      'La clave no es válida. Comprueba la clave e inténtalo de nuevo o elimina el campo para completar el registro'
  },
  createUser: {
    checkEmail: 'Mientras tanto, descarga Metrica Play en tu ordenador',
    clubCompany: 'Organización/Club',
    createdSuccessfully:
      '¡Registro exitoso! Comprueba tu correo electrónico para obtener un enlace de verificación. (Mira la carpeta de correo no deseado)',
    email: 'Correo Electrónico',
    invalidEmail: 'Correo electrónico no válido',
    job: 'Trabajo/Rol',
    lastName: 'Apellidos',
    name: 'Nombre',
    noCustomOption: 'Opción no disponible',
    noMatches: 'No hay coincidencias, escribe tu propia opción',
    password: 'Contraseña',
    passwordsDontMatch: 'Las contraseñas no coinciden',
    passwordInvalid: 'La contraseña no cumple los requisitos',
    passwordRequirements: {
      minLength: 'Al menos %{count} caracteres',
      uppercase: 'Una letra mayúscula',
      lowercase: 'Una letra minúscula',
      number: 'Un número (0-9)',
      maxLength: 'Como máximo %{count} caracteres'
    },
    phone: 'Teléfono',
    phoneCode: 'País',
    proceed: 'Continuar',
    repeatPassword: 'Repite la contraseña',
    searchPhoneCode: 'Buscar...',
    seeTermsAndConditions: 'Ver condiciones generales',
    sport: 'Deporte',
    submitting: 'Empezando...',
    title: 'Empieza con %{product}',
    signUpHere: 'Crea tu cuenta para empezar.',
    alreadyHaveAccount: '¿Ya tienes una cuenta? %{pre}Descargar%{post}',
    userKeyField: '¿Tienes un código promocional o una clave de usuario? Rellena este campo',
    signAgreement:
      'Registrarte en una cuenta de Metrica Sports significa que aceptas la %{pre1}Política de Privacidad%{post1} y los %{pre2}Términos de Servicio%{post2}'
  },
  invitation: {
    title: 'Invitación',
    subtitle:
      'Al aceptar esta nueva invitación de cuenta de Metrica Sports, serás añadido a otra cuenta de Metrica Sports.',
    description1:
      'Cuando seas añadido a la nueva cuenta de Metrica Sports, la propiedad de tu cuenta actual de Metrica Sports (y la información contenida en ella) será transferida y asignada al nuevo propietario de la cuenta de Metrica Sports. Toda la información y los datos actualmente contenidos en tu cuenta de Metrica Sports, así como cualquier información o dato guardado después de aceptar el cambio de cuenta, serán visibles y estarán disponibles para el nuevo propietario de la cuenta de Metrica Sports y para cualquier administrador(es) de dicha cuenta, para usarlos y compartirlos con otros a discreción del propietario de la cuenta.',
    description2:
      'Al hacer clic en "Acepto el cambio de mi cuenta" aceptas y autorizas lo siguiente:',
    list1:
      'La información de tu cuenta actual será transferida a la nueva cuenta de Metrica Sports.',
    list2:
      'Toda la información de la cuenta transferida a tu nueva cuenta de Metrica Sports desde tu cuenta actual podrá ser gestionada por el nuevo propietario de la cuenta y/o administrador(es).',
    list3:
      'En la nueva cuenta de Metrica Sports, tu rol será “Miembro”. Ya no tendrás privilegios de propietario ni de administrador de tu cuenta actual.',
    list4:
      'Heredarás la configuración existente de tu nueva cuenta de Metrica Sports, que puede ser más o menos restrictiva dependiendo de tu rol en la cuenta, y tu configuración podrá ser gestionada por el nuevo propietario o administrador(es) de la cuenta de Metrica Sports.',
    list5:
      'Tu configuración actual podrá ser modificada si entra en conflicto con la configuración de la cuenta nueva a la que te unes.',
    list6:
      'Es posible que tu nueva cuenta no proporcione acceso a todas las funciones que tienes en tu cuenta actual.',
    list7:
      'No es posible revertir la transferencia de tu cuenta una vez que la inicies, y toda tu información de cuenta permanecerá en una sola cuenta.',
    list8:
      'Al hacer clic en “Acepto el Cambio de Mi Cuenta”, te convertirás en un miembro gestionado de la cuenta de %{pre1}%{email}%{post1} y aceptas los %{pre2}Términos de Servicio%{post2} y la %{pre3}Declaración de Privacidad%{post3} de Metrica Sports.',
    acceptButton: 'Acepto el Cambio de Mi Cuenta',
    cancelButton: 'Rechazar',
    accepting: 'Aceptando...'
  },
  jobs: {
    academyDirector: 'Director de Academia',
    assistantCoach: 'Asistente de Entrenador',
    dataAnalyst: 'Analista de Datos',
    doctor: 'Médico',
    formerPlayer: 'Exjugador',
    goalkeeperCoach: 'Entrenador de Porteros',
    headCoach: 'Entrenador',
    journalist: 'Periodista',
    other: 'Otros',
    performance: 'Rendimiento y Fitness',
    player: 'Jugador',
    scout: 'Scout',
    sportsDirector: 'Director Deportivo',
    student: 'Estudiante',
    videoAnalyst: 'Analista de Vídeo'
  },
  sports: {
    americanFootball: 'Fútbol Americano',
    baseball: 'Béisbol',
    basketball: 'Baloncesto',
    fieldHockey: 'Hockey sobre Hierba',
    football: 'Fútbol',
    futsal: 'Fútbol Sala',
    gaelicFootball: 'Fútbol Gaélico',
    handball: 'Balonmano',
    iceHockey: 'Hockey sobre Hielo',
    lacrosse: 'Lacrosse',
    netball: 'Netball',
    other: 'Otros',
    padel: 'Pádel',
    rugby: 'Rugby',
    tennis: 'Tenis',
    volleyball: 'Voleibol'
  }
}
